module.exports = __webpack_public_path__ + "52e6-user-btn-kn.png";